// 要約推敲（短縮候補）取得用の varuna fetcher。
// ReasonCard.vue など利用側から vueContext を渡して使う。

export function buildSummarizeFetcher(vueContext) {
  if (!vueContext) return null
  const $axios = vueContext.$axios
  const $varuna = vueContext.$varuna
  const $firebase = vueContext.$firebase
  if (
    !$axios ||
    !$varuna ||
    !$varuna.endPoints ||
    !$varuna.endPoints.proofreadSummarize
  ) {
    return null
  }
  const endpoint = $varuna.endPoints.proofreadSummarize

  return function fetcher({
    text,
    targetLength,
    variationCount,
    context,
    signal
  }) {
    const uid = ($firebase && $firebase.user && $firebase.user.uid) || null
    if (!uid) {
      const err = new Error('not authenticated')
      err.code = 'UNAUTHENTICATED'
      return Promise.reject(err)
    }
    const config = { timeout: 60000 }

    // axios 0.18 は AbortController.signal 未対応 → CancelToken にブリッジ
    let cancelSource = null
    if (signal && $axios.CancelToken) {
      cancelSource = $axios.CancelToken.source()
      config.cancelToken = cancelSource.token
      if (signal.aborted) {
        cancelSource.cancel('aborted before send')
      } else {
        signal.addEventListener('abort', () => {
          if (cancelSource) cancelSource.cancel('aborted')
        })
      }
    }

    return $axios
      .post(
        endpoint,
        {
          uuid: uid,
          text,
          target_length: targetLength,
          variation_count: variationCount || 3,
          context: context || '文章'
        },
        config
      )
      .then((res) => {
        if (
          res &&
          res.data &&
          res.data.success &&
          Array.isArray(res.data.summaries)
        ) {
          return res.data.summaries
        }
        return []
      })
    // catch はしない。呼び出し側で 403 / 429 / abort を識別する必要がある
  }
}
